export enum EnvType {
  dev = 'dev',
  qa = 'qa',
  staging = 'staging',
  prod = 'prod',
}

export enum Language {
  en = 'en',
  fr = 'fr',
}

export enum ConversationStatus {
  BeforeSessionInitiate,
  SessionInitiated,
  InitialQuestion,
  ConversationStarted,
}

export enum RealmName {
  rogers = 'rogers',
  fido = 'fido',
  shaw = 'shaw',
  r4b = 'r4b',
  shawDirect = 'shawDirect',
}

export enum CdkBrand {
  rogers = 'rogers',
  fido = 'fido',
}

export enum RealmCode {
  rogers = 'r',
  fido = 'f',
  shaw = 's',
}

export enum RealmDomain {
  rogers = 'rogers.com',
  fido = 'fido.ca',
  shaw = 'shaw.ca',
}

export enum ApiSendChatMessageResponseActionTypes {
  QUICK_REPLY = 'quickReply',
  PERMANENT_REPLY = 'button',
  CLICKABLE_LINK = 'weblinks',
  THUMBS_UP_DOWN = 'thumbsUpDown',
}

export enum ChatWindowStates {
  INITIALSTATE = '',
  MINIMIZED = 'MINIMIZED',
  OPENED = 'OPENED',
}

export enum WindowMessage {
  OPEN = 'UCX-OPEN',
  CLOSE_REQUESTED = 'UCX-CLOSE-REQUESTED',
  UCX_CHANGE_LANGUAGE = 'UCX-CHNG-LANGUAGE',
  MAXIMIZE = 'UCX-MAXIMIZE',
  SS_CLOSE = 'SS-CLOSE',
  UPDATE_VA_STORE = 'UCX-UPDATE-VA-STORE',
  POPOVER_CLOSE = 'UCX-POPOVER-CLOSE',
}

export enum LiveChatEndReason {
  EMPTY = '',
  USER_CANCELED = 'User Canceled',
  USER_ENDED = 'User Ended',
  OPERATOR_ENDED = 'Operator Ended',
  PLATFORM_TRANSFER = 'Platform Transfer',
}

export enum CreateChatType {
  API = 'api',
  IFRAME = 'iframe',
  GenesysCX = 'genesysCX',
}

export enum LiveChatMethods {
  setConnection = 'setConnection',
  receiveOperatorMessage = 'receiveOperatorMessage',
  receiveSystemMessage = 'receiveSystemMessage',
  positionChanged = 'positionChanged',
  setOperatorTyping = 'setOperatorTyping',
  closeConnection = 'closeConnection',
  setChatId = 'setChatId',
}

export enum OverlayType {
  Empty = '',
  Confirmation = 'Confirmation',
  Safesend = 'Safesend',
  Transcript = 'Transcript',
  PostEscalation = 'PostEscalation',
  CreditCard = 'CreditCard',
  Iframe = 'Iframe',
}

export enum EmailTranscriptStatus {
  Requested = 'Requested',
  Submitted = 'Submitted',
  Failed = 'Failed',
}

export enum EscalationType {
  Direct = 'Direct',
  Curated = 'Curated',
  None = 'None',
}

export enum PendingActionType {
  empty = '',
  callDialogApi = 'callDialogApi',
  escalateToLiveChat = 'escalateToLiveChat',
  startNewSession = 'startNewSession',
}

export enum FloatingButtonStates {
  OPEN = 'OPEN',
  MINIMIZED = 'MINIMIZED',
  FLOATING = 'FLOATING',
}

export enum ClickableLinkActionType {
  SIGN_IN_YES = 'SIGN_IN_YES',
  SIGN_IN_NO = 'SIGN_IN_NO',
  CONTINUE_CONVERSATION = 'CONTINUE_CONVERSATION',
  USE_MY_COORDINATES = 'USE_MY_COORDINATES',
  PPC_OFFER_RESPONSE = 'PPC_OFFER_RESPONSE',
  PPC_TERMS_RESPONSE = 'PPC_TERMS_RESPONSE',
}

export enum MessageType {
  VA = 'va',
  OPERATOR = 'operator',
  USER = 'user',
  SYSTEM = 'system',
}

export enum ApiSendChatMessageResponseMessageTitleTypes {
  CALLBACK_SINGLE_DATE_MULTI_TIMESPAN = 'call_back#single_date_multi_timespan_time_list',
  CALLBACK_SINGLE_DATE_SINGLE_TIMESPAN = 'call_back#single_date_single_timespan_time_list',
  CALLBACK_MULTI_DATE_SINGLE_TIMESPAN = 'call_back#multi_date_single_timespan_time_list',
  CALLBACK_MULTI_DATE_MULTI_TIMESPAN = 'call_back#multi_date_multi_timespan_time_list',
  PAY_ONLINE_THROUGH_CREDITCARD = 'pay_online#pay_through_creditcard',
}

export enum ComponentType {
  DialogMessageComponent = 'DialogMessageComponent',
  SystemMessageComponent = 'SystemMessageComponent',
  SafeSendComponent = 'SafeSendComponent',
  SafeSendBubbleComponent = 'SafeSendBubbleComponent',
  PostEscalationMenuComponent = 'PostEscalationMenuComponent',
  OverlayComponent = 'OverlayComponent',
  EmailTranscriptComponent = 'EmailTranscriptComponent',
  PaymentOverlayComponent = 'PaymentOverlayComponent',
  IframeComponent = 'IframeOverlayComponent',
  BurialStatusCardComponent = 'BurialStatusCardComponent',
  AlertComponent = 'AlertComponent',
}

export enum ActionType {
  LinkClick = 'handleClickableLink',
  CannedResponseClick = 'onCannedResponseClick',
  onPostEscalationMenuSelection = 'onPostEscalationMenuSelection',
  onCancelPostEscalationMenuSelection = 'onCancelPostEscalationMenuSelection',
  UpdateSafeSendStatus = 'updateSafeSendStatus',
  closeLiveChatConnection = 'closeLiveChatConnection',
  closeConfirmationOverlay = 'closeConfirmationOverlay',
  cancelConfirmationOverlay = 'cancelConfirmationOverlay',
  requestEmailTranscript = 'requestEmailTranscript',
  closeEmailTranscript = 'closeEmailTranscript',
  HandlePayment = 'onPayment',
  HandleCancelPayment = 'onCancelPayment',
}

export enum VaFalseCannedResponse {
  SIGN_INTO_ACCOUNT = 'SIGN_INTO_ACCOUNT',
  UNABLE_TO_SIGN_IN = ' UNABLE_TO_SIGN_IN',
  NOT_A_CUSTOMER = 'NOT_A_CUSTOMER',
  CONTEXT_VALUE = 'Non-Customer',
}

export enum MessageSubType {
  PAYMENT = 'payment',
  SAFESEND = 'SAFESEND',
  LIVE_CHAT_UNAVAILABLE = 'LIVE_CHAT_UNAVAILABLE',
  ASK_TO_LOGIN = 'ASK_TO_LOGIN',
}

export enum LiveChatPlatform {
  dx = 'GENESYS-DX',
  cx = 'GENESYS-CX',
}

export const vaFalseInitialDialog = 'Constant For Va False Initial Dialog';
